import React from "react";

const Loading = () => {
  const estiloDiv = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  };
  return (
    <div style={estiloDiv}>
      <div class="row">
        <div class="col-lg-12 center">
          <div className="spinner-border text-primary" role="status"></div>
        </div>
      </div>
    </div>
  );
};

export default Loading;
